import { createSlice } from '@reduxjs/toolkit';

const ui = createSlice({
  name: 'ui',
  initialState: {
    sidebar: 'close'
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebar = state.sidebar === 'open' ? 'close' : 'open';
    },
    setSidebar: (state, action) => {
      state.sidebar = action.payload;
    },
  },
  extraReducers: () => {
  },
});
export const { toggleSidebar, setSidebar } = ui.actions;
export default ui.reducer;
